import { IntlShape } from "react-intl";
import {
  array,
  InferOutput,
  maxLength,
  nullable,
  object,
  pipe,
  string,
  trim,
} from "valibot";

export const SHORT_DESCRIPTION_MAX_SIZE = 50;

export const schemaFactory = (intl: IntlShape) =>
  object({
    shortDescription: pipe(
      string(),
      trim(),
      maxLength(SHORT_DESCRIPTION_MAX_SIZE, (issue) =>
        intl.formatMessage(
          { defaultMessage: "{count}/{maxChar} characters used" },
          { count: issue.input.length, maxChar: SHORT_DESCRIPTION_MAX_SIZE },
        ),
      ),
    ),
    tags: array(string()),
    license: nullable(string()),
  });

export type Schema = ReturnType<typeof schemaFactory>;
export type SchemaOutput = InferOutput<Schema>;
